import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/intro',
  screens: {
    introModal: '/modal',
    borrowerNext: '/borrow',
    lenderNext: '/lend',
    interests: '/quick-publish',
    quickInterests: '/quick-interests',
    'quick-new-choose': '/choose',
    'quick-new-confirm': '/confirm',
    'quick-new-thanks': '/thanks',
  },
};
